import CapabilityInput from './CapabilityInput';

export default CapabilityInput;
